/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_Faq_A3Inputs */

const en_guide_what_is_json_faq_a3 = /** @type {(inputs: Guide_What_Is_Json_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON itself has no size limit. Practical limits depend on the parser and available memory. Most web APIs limit request/response sizes to a few megabytes, while file-based JSON can be much larger.`)
};

const ko_guide_what_is_json_faq_a3 = /** @type {(inputs: Guide_What_Is_Json_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 자체에는 크기 제한이 없습니다. 실질적인 제한은 파서와 사용 가능한 메모리에 따라 달라집니다. 대부분의 웹 API는 요청/응답 크기를 수 MB로 제한하지만, 파일 기반 JSON은 훨씬 더 클 수 있습니다.`)
};

const ja_guide_what_is_json_faq_a3 = /** @type {(inputs: Guide_What_Is_Json_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON自体にはサイズ制限がありません。実際の制限はパーサーと利用可能なメモリに依存します。ほとんどのWeb APIはリクエスト/レスポンスのサイズを数メガバイトに制限していますが、ファイルベースのJSONはそれよりはるかに大きくできます。`)
};

/**
* | output |
* | --- |
* | "JSON itself has no size limit. Practical limits depend on the parser and available memory. Most web APIs limit request/response sizes to a few megabytes, whi..." |
*
* @param {Guide_What_Is_Json_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_faq_a3 = /** @type {((inputs?: Guide_What_Is_Json_Faq_A3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_Faq_A3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_faq_a3(inputs)
	if (locale === "ko") return ko_guide_what_is_json_faq_a3(inputs)
	return ja_guide_what_is_json_faq_a3(inputs)
});